import React from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'

// const StyledTableCell = withStyles((theme) => ({
//   head: {
//     backgroundColor: theme.palette.common.black,
//     color: theme.palette.common.white,
//   },
//   body: {
//     fontSize: 14,
//   },
// }))(TableCell)

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#3f51b5'
    }
  }
}))(TableRow)

const useStyles = makeStyles({
  headCell: {
    textAlign: 'right',
    color: 'white'
  }
})

const columns = ['P21', 'R21', 'P19', 'R19']

export default function TablaCamionesEnCircuito ({ valores }) {
  const classes = useStyles()
  const data = [valores[0], valores[1], valores[2], valores[3]]

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size='small' aria-label='a dense table'>
        <TableHead>
          <StyledTableRow>
            {columns.map((column) => (
              <TableCell key={column} className={classes.headCell}><strong>{column}</strong></TableCell>
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {data.map((valor) => (
              <TableCell>{(valor > 0) ? valor : ' - '}</TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
